import { TFunc } from 'libs/i18n';

export const formatFileSize = (sizeInBytes: number, t: TFunc): string => {
  const bytesInMb = 1024 * 1024;

  const mb = Number((sizeInBytes / bytesInMb).toFixed(1));

  if (mb >= 1) {
    return t('components.file.formatSize.mb', { size: mb });
  }

  const kb = Math.round(sizeInBytes / 1024);

  return t('components.file.formatSize.kb', { size: kb });
};
